// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExclamationTwoToneSvg from "@ant-design/icons-svg/es/asn/FileExclamationTwoTone";
import AntdIcon from '../components/AntdIcon';

var FileExclamationTwoTone = function FileExclamationTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationTwoToneSvg
  }));
};

FileExclamationTwoTone.displayName = 'FileExclamationTwoTone';
export default React.forwardRef(FileExclamationTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileExclamationTwoTone.js
// module id = 1103
// module chunks = 0